export default {
	'user-create': 'إنشاء مستخدم',
	'user-edit': 'تعديل مستخدم',
	'edit-account-status': 'تعديل حالة حساب',
	'are-you-sure-to-deactivate-an-account': 'هل أنت متأكد من إيقاف حساب ',
	'are-you-sure-to-activate-an-account': 'هل أنت متأكد من تشغيل حساب ',
	'user-power': 'صلاحيات المستخدم',
	'store-name': 'اسم المتجر',
	'power-type': 'نوع الصلاحية',
	casher: 'كاشير',
	'executive-director': 'مدير متجر',
	optional: 'اختياري',
	'change-password': 'تغير كلمة المرور',
	'password-has-been-modified-successfully': 'تم تعديل كلمة المرور بنجاح',
	active: 'نشط',
	stopped: 'متوقف',
	'user-info': 'بيانات المستخدم',
	'the-user-has-been-added-successfully': 'تم إضافة المستخدم بنجاح',
	'user-data-has-been-modified-successfully': 'تم تعديل بيانات المستخدم بنجاح',
	viewer: 'مدير (إطلاع)',
	'user-permissions-for': 'صلاحيات المستخدم لـ',
	permissions: {
		'permission-type': 'نوع الصلاحية',
		allowed: 'مسموح',
		read: 'قراءة',
		'not-Allowed': 'غير مسموح',
	},

	permissionTypes: {
		configs: 'بيانات المتجر',
		currencies: 'العملات',
		users: 'المستخدمين',
		stores: 'المتاجر',
		cashboxes: 'الصناديق النقدية',
		'account-statement': 'كشف حساب',
		'cash-journal': 'يومية الصندوق',
		'closed-cash-journal': 'يوميات الصندوق المغلقة',
		'all-cash-journal': 'كل يوميات الصناديق',
		'detailed-day': 'مخلص اليوم',
		'daily-table': 'جدول اليومية',
		'item-tree': 'شجرة المواد',
		'sale-invoice': 'فاتورة البيع',
		'buy-invoice': 'فاتورة الشراء',
		'sale-refund-invoice': 'فاتورة مرتجع البيع',
		'all-invoices': 'جميع الفواتير',
		'items-journal': 'يومية المواد',
		'all-item-journals': 'كل يوميات المواد',
		'item-statement': 'كشف مادة',
		'inventory-report': 'جرد المواد',
		reports: 'التقارير',
		'close-cash-journal': 'إغلاق يومية الصندوق',
		'invoice-discount': 'حسم الفاتورة',
		'invoice-change-account': 'تغيير حساب الفاتورة',
		'invoice-card': 'دفع الفاتورة بالبطاقة',
		'invoice-internal': 'دفع الفاتورة داخلياً',
		'invoice-debt': 'دفع الفاتورة بالدين',
		'account-tree': 'شجرة الحسابات',
		'invoice-entries-discount': 'الحسم على مستوى القيد في الفاتورة',
	}
}